import { CustomsInventoryItemMapper } from './CustomsInventoryItem/CustomsInventoryItemMapper.js';
import { CustomsUserInformationMapper } from './CustomsUserInformation/CustomsUserInformationMapper.js';

/**
 * Plain objects Packlink's API response representation.
 *
 */

/**
 * Api response for draft customs invoice
 */

/**
 * Payload used in POST and PUT endpoints
 *
 */

/**
 * Api response for customs invoice url
 */

class CustomsInvoiceMapper {
  /**
   * Takes a ICustomsInvoiceApiResponse from Packlink's API and returns a CustomsInvoice.
   *
   * @param response  ICustomsInvoiceApiResponse response from Packlink's API.
   *
   */

  static createModelFromResponse(response) {
    var _inventory$0$item_val, _inventory$, _inventory$$item_valu;
    if (!response) {
      return undefined;
    }
    const {
      data: {
        inventory_of_contents: inventory = [],
        sender,
        receiver,
        reason_for_export: reasonForExport,
        invoice_number: invoiceNumber,
        shipment_details: shipmentDetails
      }
    } = response;

    // All inventory items must have same currency, so customsInvoiceData attribute has been moved up to avoid duplication
    const currency = (_inventory$0$item_val = (_inventory$ = inventory[0]) === null || _inventory$ === void 0 ? void 0 : (_inventory$$item_valu = _inventory$.item_value) === null || _inventory$$item_valu === void 0 ? void 0 : _inventory$$item_valu.currency) !== null && _inventory$0$item_val !== void 0 ? _inventory$0$item_val : '';
    return {
      id: response.id,
      currency,
      inventory: inventory.map(item => CustomsInventoryItemMapper.createModelFromResponse(item)),
      sender: CustomsUserInformationMapper.createCustomsAddressFromResponse(sender),
      receiver: CustomsUserInformationMapper.createCustomsAddressFromResponse(receiver),
      reasonForExport,
      invoiceNumber,
      senderTaxInformation: CustomsUserInformationMapper.createTaxInformationFromResponse(sender),
      receiverTaxInformation: CustomsUserInformationMapper.createTaxInformationFromResponse(receiver),
      shipmentDetails: this.createShipmentDetailsFromResponse(shipmentDetails)
    };
  }
  static createShipmentDetailsFromResponse(details) {
    if (!details) {
      return undefined;
    }
    return {
      cost: details.cost.value,
      parcelCount: details.parcels_size,
      parcelWeight: details.parcels_weight
    };
  }

  /**
   * Creates API payload required for endpoints that creates and updates CustomsInvoices
   */

  static createApiPayload(_ref) {
    let {
      inventory = [],
      currency = '',
      ...customsInvoiceData
    } = _ref;
    return {
      id: customsInvoiceData.id,
      inventory_of_contents: inventory.map(item => CustomsInventoryItemMapper.createApiPayload(item, currency)),
      sender: CustomsUserInformationMapper.createApiPayload({
        address: customsInvoiceData.sender,
        taxInformation: customsInvoiceData.senderTaxInformation
      }),
      receiver: CustomsUserInformationMapper.createApiPayload({
        address: customsInvoiceData.receiver,
        taxInformation: customsInvoiceData.receiverTaxInformation
      }),
      shipment_details: this.createCustomsShipmentDetailsApiPayload(customsInvoiceData.shipmentDetails, currency),
      reason_for_export: customsInvoiceData.reasonForExport,
      invoice_number: customsInvoiceData.invoiceNumber,
      signature: this.createSignatureApiPayload(customsInvoiceData.signature)
    };
  }
  static createSignatureApiPayload(signature) {
    var _signature$fullName, _signature$city;
    if (!signature) {
      return undefined;
    }
    return {
      full_name: (_signature$fullName = signature.fullName) !== null && _signature$fullName !== void 0 ? _signature$fullName : '',
      city: (_signature$city = signature.city) !== null && _signature$city !== void 0 ? _signature$city : ''
    };
  }
  static createCustomsShipmentDetailsApiPayload(shipmentDetails, currency) {
    if (!shipmentDetails) {
      return undefined;
    }
    return {
      cost: {
        currency: currency !== null && currency !== void 0 ? currency : '',
        value: shipmentDetails.cost
      },
      parcels_size: shipmentDetails.parcelCount,
      parcels_weight: shipmentDetails.parcelWeight
    };
  }
}

export { CustomsInvoiceMapper };
//# sourceMappingURL=CustomsInvoiceMapper.js.map
